<template>
  <div class="overflow-y-auto menuContainer z-10 pb-10" ref="menuContainer">
    <ul class="metismenu overflow-y-auto" id="menu">
        <MenuItem
        v-for="(subMenu, idx) in getParents"
          :key="idx"
          :menuItem="subMenu"
          :menuArr="navigationItems"
          v-on:click-action="$emit('click-action')"
        />
    </ul>
  </div>
</template>

<style scoped>
.settings-opacity {
  opacity: 0.75;
}
.settings-border {
  border-bottom: solid 1px rgb(255, 255, 255, 0.7);
}
@keyframes open-menu {
  from {
    right: -25rem;
  }
  to {
    right: 0px;
  }
}

@keyframes close-menu {
  from {
    right: 0px;
  }
  to {
    right: -25rem;
  }
}

.menuContainer {
  background-image: linear-gradient(#003764, #1479a8);
  background-color: #000;
  /* height: calc(100vh - 60px - env(safe-area-inset-top)); */
  width: 100%;
}

@media screen and (min-width: 64em) {
  .menuContainer {
    width: 25rem;
  }
}
</style>

<script>
import router from "../../router";
import store from "../../store";
import { mapGetters } from "vuex";

import MenuItem from "@/components/Menu/MenuItem";
import MetisMenu from "metismenujs";

export default {
  components: { MenuItem },
  data() {
    return {
      isInit: false,
    };
  },
  computed: {
    ...mapGetters("navigation", ["navigationItems"]),
    /**
     * get parent menu items that match the selected menuItem
     */
    getParents() {
      let navParentArr;

      if (this.navigationItems !== null) {
        navParentArr = this.navigationItems.filter(
          (item) =>
            item.parent === undefined ||
            item.parent === null ||
            item.parent.length === 0
        );
      }

      return navParentArr;
    },
  },

  methods: {
    /**
     * window resize listener
     */
    handleResize(e) {
      new MetisMenu("#menu", { toggle: false });
    },
  },
  // ------------------
  // VueJS Lifecycle Hooks
  // ------------------
  created() {
    document.addEventListener("resize", this.handleResize);
  },
  async mounted() {
    try {
      await store.dispatch("navigation/loadNavigation");
    } catch (e) {
      // try one more time
      store.dispatch("navigation/loadNavigation");
    }
  },
  updated() {
    // -- this is needed otherwise browser refresh will reset break things
    if (!this.isInit) {
      new MetisMenu("#menu", { toggle: false });
    }

    this.isInit = true;
    // --
  },
  destroyed() {
    document.removeEventListener("resize", this.handleResize);
  },
};
</script>
